import { jsx } from 'react/jsx-runtime';
import { c as classNames, u as useEGDSContext } from '../index_orig/index-chunk.esm.js';
import * as React from 'react';
import styles from '../styles/uitk-egds-skeleton.css';
const EGDSSkeletonLineHeightMap = [['type-100', 'font__line_height__100'], ['type-200', 'font__line_height__200'], ['type-300', 'font__line_height__300'], ['type-400', 'font__line_height__400'], ['type-500', 'font__line_height__500'], ['type-600', 'font__line_height__600'], ['type-700', 'font__line_height__700'], ['type-800', 'font__line_height__800'], ['type-900', 'font__line_height__900'], ['heading-1', 'typography__heading_1__font_line_height'], ['heading-2', 'typography__heading_2__font_line_height'], ['heading-3', 'typography__heading_3__font_line_height'], ['heading-4', 'typography__heading_4__font_line_height'], ['heading-5', 'typography__heading_5__font_line_height'], ['heading-6', 'typography__heading_6__font_line_height'], ['heading-7', 'typography__heading_7__font_line_height'], ['heading-8', 'typography__heading_8__font_line_height'], ['subheading', 'typography__subheading__font_line_height'], ['paragraph-1', 'typography__paragraph_1__font_line_height'], ['paragraph-2', 'typography__paragraph_2__font_line_height'], ['paragraph-3', 'typography__paragraph_3__font_line_height']];
const EGDSSkeletonLineHeights = new Map(EGDSSkeletonLineHeightMap);
const getClassNameList = classNames.bind(styles);
const EGDSSkeleton = props => {
  const {
    className,
    animation,
    type,
    transitionType,
    isTransitioned
  } = props;
  const {
    lineHeight,
    lineLength
  } = props;
  const {
    cornerRadius
  } = props;
  const {
    data: contextData
  } = useEGDSContext();
  const {
    sequentialIndex
  } = contextData ?? props;
  const sequentialIndexValue = `${sequentialIndex > 0 ? `calc(var(--motion__duration__3) * ${sequentialIndex})` : '0ms'}`;
  const skeletonRef = React.useRef(null);
  const fadeOut = transitionType === 'fade-out';
  const refreshed = transitionType === 'refreshed';
  const wrapperClassNames = getClassNameList(EGDSSkeleton.baseClassName, className, animation && `${EGDSSkeleton.baseClassName}-animation`, `${EGDSSkeleton.baseClassName}-${type}`, refreshed && !isTransitioned && `skeleton-is-hidden`, type === 'line' && lineLength && `${EGDSSkeleton.baseClassName}-line-${lineLength}`, type === 'block' && cornerRadius && `${EGDSSkeleton.baseClassName}-block-rounded`);
  const lineHeightStyle = () => {
    if (type !== 'line' || !lineHeight) return '';
    return typeof lineHeight === 'number' ? `${lineHeight}px` : `var(--${EGDSSkeletonLineHeights.get(lineHeight)})`;
  };
  const cornerRadiusStyle = () => {
    if (type !== 'block' || !cornerRadius) return '';
    return typeof cornerRadius === 'number' ? `${cornerRadius}px` : `var(--skeleton__block__corner_radius)`;
  };
  const wrapperStyles = {
    [`--delay`]: sequentialIndexValue,
    ...(type === 'line' && lineHeight && {
      [`--text-size`]: lineHeightStyle()
    }),
    ...(type === 'block' && {
      [`--corner-radius`]: cornerRadiusStyle()
    })
  };
  // First keyframe values are for fade-out, second are for refreshed page
  const transitionDetails = {
    keyframes: [{
      opacity: fadeOut ? 1 : 0
    }, {
      opacity: fadeOut ? 0 : 1
    }],
    options: {
      duration: 300,
      easing: fadeOut ? 'cubic-bezier(0.5, 0, 0.5, 1)' : 'linear',
      iterations: 1
    }
  };
  // Add in animation transitions if fadeOut or refreshed are true
  React.useEffect(() => {
    const currSkeleton = skeletonRef.current;
    if (isTransitioned && currSkeleton) {
      refreshed && currSkeleton.classList.remove('skeleton-is-hidden');
      currSkeleton.animate(transitionDetails.keyframes, transitionDetails.options);
      Promise.all(currSkeleton.getAnimations().map(transition => transition.finished)).then(() => fadeOut && currSkeleton?.classList.add('skeleton-is-hidden'));
    } else {
      fadeOut && currSkeleton?.classList.remove('skeleton-is-hidden');
      refreshed && currSkeleton?.classList.add('skeleton-is-hidden');
    }
  }, [isTransitioned]);
  return jsx("div", {
    className: wrapperClassNames,
    role: "presentation",
    ref: skeletonRef,
    style: wrapperStyles
  });
};
EGDSSkeleton.baseClassName = 'uitk-skeleton';
EGDSSkeleton.defaultProps = {
  animation: true,
  type: 'line',
  lineLength: 'primary',
  transitionType: undefined,
  isTransitioned: false
};
EGDSSkeleton.displayName = 'EGDSSkeleton';

/**
 * Returns a Block Skeleton
 *
 * @deprecated use <EGDSSkeleton type="block" />
 */
const EGDSBlockSkeleton = props => {
  const {
    animation,
    className,
    type
  } = props;
  const wrapperClassNames = classNames(className);
  const cornerRadiusValue = type && type === 'rounded' ? 'defaultValue' : 0;
  return jsx(EGDSSkeleton, {
    animation: animation,
    type: "block",
    className: wrapperClassNames,
    cornerRadius: cornerRadiusValue
  });
};
EGDSBlockSkeleton.displayName = 'EGDSBlockSkeleton';
EGDSBlockSkeleton.defaultProps = {
  type: 'square'
};

/**
 * Returns a Line Skeleton
 *
 * @deprecated use <EGDSSkeleton type="line" />
 */
const EGDSLineSkeleton = props => {
  const {
    animation,
    className,
    type
  } = props;
  const wrapperClassNames = classNames(className);
  return jsx(EGDSSkeleton, {
    className: wrapperClassNames,
    type: "line",
    animation: animation,
    lineLength: type
  });
};
EGDSLineSkeleton.displayName = 'EGDSLineSkeleton';
EGDSLineSkeleton.defaultProps = {
  type: 'primary'
};
export { EGDSSkeleton as E, EGDSBlockSkeleton as a, EGDSLineSkeleton as b };